export default "__VITE_ASSET__DJwqZnF4__"